export const weightStringFromRange = (range: string): string => {
  return range && [...new Set(range)].map((v) => `${v}`).join("-");
};
